import React from 'react';
import { FiCircle, FiTriangle, FiX } from 'react-icons/fi';

import { IcoMoonSpinner4 } from '../ico-moon';

function getCapacityIcon(percentage, active) {
  if (percentage === 100 || !active) {
    return FiX;
  }
  if (percentage > 60) {
    return FiTriangle;
  }
  return FiCircle;
}

export default function renderCapacityIndicator(percentage, active, loading) {
  if (active && (percentage === undefined || loading)) {
    return <IcoMoonSpinner4 className="spin" size="100%" />;
  }
  const Icon = getCapacityIcon(percentage, active);
  return <Icon size="100%" />;
}
